import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksStaffPayments(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		options
	)
}
function _getRegulationsStagesPlanWorksStaffPaymentPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksStaffPaymentPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksStaffPayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
		options
	)
}

function _getRegulationsStagesPlanWorksStaffPayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
		options
	)
}

function _patchRegulationsStagesPlanWorksStaffPayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
		options
	)
}

function _putRegulationsStagesPlanWorksStaffPayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
		options
	)
}

function _deleteRegulationsStagesPlanWorksStaffPayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]: _getRegulationsStagesPlanWorksStaffPayments,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_PREVIEW]: _getRegulationsStagesPlanWorksStaffPaymentPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_POPUP]: _getRegulationsStagesPlanWorksStaffPaymentPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: _createRegulationsStagesPlanWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: _getRegulationsStagesPlanWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: _patchRegulationsStagesPlanWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: _putRegulationsStagesPlanWorksStaffPayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: _deleteRegulationsStagesPlanWorksStaffPayment,
}
